/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { FaFileContract, FaFileUpload, FaPenFancy, FaTimes, FaWrench } from "react-icons/fa";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import EtapaContrato from "../../../onboarding/EtapaContrato";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { TipoFormulario } from "../../../../services/constantes";
import { ApiError, Campo, ModeloContrato } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { obterIdTenent, usuarioTemAlgumaPermissao } from "../../../../services/seguranca";
import { useHistory } from "react-router-dom";
import { FaInfoCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useFiliais } from "../../../../hooks/useFiliais";

function ModeloContratoListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [modelos, setModelos] = useState<ModeloContrato[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [modeloSelecionado, setModeloSelecionado] = useState<ModeloContrato>({} as ModeloContrato);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [exemploExpandido, setExemploExpandido] = useState<boolean>(false);
    const [usaEditorV2, setUsaEditorV2] = useState(false);
    // Criar o modelo a partir de um contrato já preenchido (a mesma leitura do onboarding).
    const [exibirAprender, setExibirAprender] = useState(false);
    const [exibirEscolha, setExibirEscolha] = useState(false);
    const [aberturasAprender, setAberturasAprender] = useState(0);

    const history = useHistory();

    useEffect(() => {
        const buscarFlagEditorV2 = async () => {
            try {
                const response = await api.get(`/Empresa/${obterIdTenent(token)}`);
                setUsaEditorV2(Boolean(response.data?.usaEditorContratoV2));
            } catch {
                setUsaEditorV2(false);
            }
        };
        buscarFlagEditorV2();
    }, [token]);

    const colunas = [
        { field: 'titulo', headerName: 'Título', flex: 1 },
        { field: 'descricao', headerName: 'Descrição', flex: 1 },
        {
            field: 'ativo', headerName: 'Status', flex: 1, renderCell: (params: any) => {
                let ativo = params.value;
                let status = "";
                let backgroundColor;

                if(Boolean(ativo)) {
                    backgroundColor = '#4CAF50';
                    status = "Ativo";
                } else {
                    backgroundColor = '#f44336';
                    status = "Inativo";
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                };

                return (
                    <span style={labelStyle}>
                        {status}
                    </span>
                );
            },
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const campoFilial = getCampoFilial({ linha: 1, coluna: 1, largura: 12 });

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Título', nome: 'titulo', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true, tutorialLink: "https://youtu.be/K--okUsfQxI" },
        // Gente colava o contrato inteiro aqui: a descrição é só um resumo para achar o modelo na lista; o texto
        // do contrato vai no documento (editor), depois de salvar.
        {
            label: 'Descrição (não é o conteúdo do contrato)', nome: 'descricao', required: true, tipo: 'memo', largura: 12, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true,
            maximoCaracteres: 150,
            extraProps: { altura: '70px', placeholder: 'Um resumo para achar o modelo na lista. Ex.: Contrato padrão de motos, locação semanal' },
            ajudinha: { texto: 'O texto do contrato você escreve no documento, que abre depois de salvar (ou em Editar Documento).', autoCloseTime: 0 },
        },
        { label: 'Ativo', nome: 'ativo', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 3, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemAlgumaPermissao(token, ['contrato_visualizar']);

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        toast.error("Não foi possível continuar a operação Modelo de Contrato: " + error.response?.data.Mensagem);
    }

    const chamarEditorDeDocumento = (idModeloContrato: string) => {
        history.push({
            pathname: usaEditorV2 ? '/editor-contrato-v2' : '/editor-contrato',
            state: { idModeloContrato: idModeloContrato }
        });
    }

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success("Modelo de Contrato salvo com sucesso");
        setFezAlgumaAcao(true);

        if(modo == TipoFormulario.tpCadastro) {
            chamarEditorDeDocumento(response.data.id);
        }
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    // Cadastrar pergunta antes: começar do zero (formulário + editor) ou a partir de um contrato pronto.
    const handleCadastrar = () => {
        if (usuarioTemAlgumaPermissao(token, ['contrato_novo'])) {
            setExibirEscolha(true);
        } else {
            toast.error("Você não tem permissão para cadastrar um novo Modelo de Contrato");
        }
    }

    const comecarDoZero = () => {
        setExibirEscolha(false);
        if (usuarioTemAlgumaPermissao(token, ['contrato_novo'])) {
            setModo(TipoFormulario.tpCadastro)
            setModeloSelecionado({} as ModeloContrato);
            setExibirFormModal(true);
        } else {
            toast.error("Você não tem permissão para cadastrar um novo Modelo de Contrato");
        }
    }

    const abrirAprender = () => {
        setExibirEscolha(false);
        if (!usuarioTemAlgumaPermissao(token, ['contrato_novo'])) {
            toast.error("Você não tem permissão para cadastrar um novo Modelo de Contrato");
            return;
        }
        setAberturasAprender(n => n + 1);
        setExibirAprender(true);
    }

    const concluirAprender = (idModelo?: string) => {
        setExibirAprender(false);
        if (idModelo) {
            toast.success("Modelo de Contrato criado com sucesso");
            setRealizarConsulta(true);
        }
    }

    // A leitura automática não deu certo: segue pelo cadastro normal (formulário e depois o editor) e avisa.
    const falhouAprender = (motivo: string) => {
        setExibirAprender(false);
        toast.info(`${motivo} Seguimos pelo cadastro normal: dê um nome ao modelo e, ao avançar, cole ou escreva o texto do contrato no editor.`, { autoClose: 10000 });
        comecarDoZero();
    }

    const personalizarAprendido = (idModelo: string) => {
        setExibirAprender(false);
        setRealizarConsulta(true);
        if (usuarioTemAlgumaPermissao(token, ['contrato_editar'])) {
            chamarEditorDeDocumento(idModelo);
        } else {
            toast.info("Modelo criado. Para personalizar o documento, peça a quem tem permissão de editar.");
        }
    }

    const handleEditar = (modeloContrato: any) => {
        if (usuarioTemAlgumaPermissao(token, ['contrato_editar'])) {
            setModo(TipoFormulario.tpEdicao)
            setModeloSelecionado(modeloContrato);
            setExibirFormModal(true);
        } else {
            toast.error("Você não tem permissão para editar um Modelo de Contrato");
        }
    }

    const handleExclusao = async (modeloContrato: ModeloContrato) => {
        if (usuarioTemAlgumaPermissao(token, ['contrato_excluir'])) {
            setCarregando(true);
            await api.delete(`/ModeloContrato/${modeloContrato.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success("Modelo de Contrato foi excluído com sucesso");
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = (modeloContrato: any) => {
        if (usuarioTemAlgumaPermissao(token, ['contrato_visualizar'])) {
            setModeloSelecionado(modeloContrato);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    const handleOpenEditor = (modelo: ModeloContrato) => {
        if (usuarioTemAlgumaPermissao(token, ['contrato_editar'])) {
            if(modelo.id) {
                setModeloSelecionado(modelo);
                chamarEditorDeDocumento(modelo.id);
            }
        } else {
            toast.error("Você não tem permissão para editar o documento");
        }
    };

    useEffect(() => {
        const fetchModeloContratoPorEmpresa = async () => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`ModeloContrato/PorEmpresa/${obterIdTenent(token)}`)
                    .then(response => {
                        setTimeout(() => {
                            setModelos(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        tratarErro(error);
                    });
            }
        }

        fetchModeloContratoPorEmpresa();
    }, [temPermissao, realizarConsulta, token]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('contrato')}
                    colunas={colunas}
                    linhas={modelos}
                    nomeEntidade="Modelo de Contrato"
                    nomePropriedade="titulo"
                    carregando={carregando}
                    IconeEntidade={FaFileContract}
                    exibirAcoesDeCrud={true}
                    acoesExtras={[
                        {
                            Texto: 'Editar Documento', Icone: FaFileContract, OnClick(entidade) {
                                handleOpenEditor(entidade as ModeloContrato);
                            }
                        }
                    ]}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setModeloSelecionado}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('ModeloContrato', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('ModeloContrato', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalForm
                    urlTutorial="https://youtu.be/K--okUsfQxI"
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    onShow={() => {
                        if (modo == TipoFormulario.tpCadastro) {
                            setEntidadeParaAtualizarNoModal({ ativo: true })
                            setForcarAtualizacaoDeEntidadeNoModal(true);
                        }
                    }}
                    tituloBotaoOk={modo == TipoFormulario.tpCadastro ? "Avançar" : "Salvar"}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Aqui você pode cadastrar modelos de contrato que serão utilizados nas locações, sendo gerados automaticamente com base nos dados de cada locação.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={modeloSelecionado}
                    apiConfig={
                        {
                            endpoint: "modeloContrato",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                />

                <Modal show={exibirEscolha} onHide={() => setExibirEscolha(false)} centered size="lg">
                    <Modal.Body style={{ padding: '22px 26px 26px', position: 'relative' }}>
                        <button type="button" aria-label="Fechar" title="Fechar" onClick={() => setExibirEscolha(false)}
                            style={{ position: 'absolute', top: 14, right: 16, border: 'none', background: 'none', color: '#6b7280', fontSize: 18, cursor: 'pointer', padding: 4, lineHeight: 0 }}>
                            <FaTimes />
                        </button>
                        <TituloEscolha>Novo modelo de contrato</TituloEscolha>
                        <SubtituloEscolha>Como você quer começar?</SubtituloEscolha>
                        <GradeEscolha>
                            <CartaoEscolha type="button" onClick={abrirAprender}>
                                <span className="selo">Mais rápido</span>
                                <FaFileUpload className="icone" />
                                <strong>Usar um contrato que já tenho</strong>
                                <span>Envie um contrato em Word ou PDF, pode ser um já preenchido. A IA identifica os dados do cliente e do veículo e monta o modelo.</span>
                            </CartaoEscolha>
                            <CartaoEscolha type="button" onClick={comecarDoZero}>
                                <FaPenFancy className="icone" />
                                <strong>Começar do zero</strong>
                                <span>Escreva o contrato no editor e insira os campos que o sistema preenche em cada locação.</span>
                            </CartaoEscolha>
                        </GradeEscolha>
                    </Modal.Body>
                </Modal>

                <Modal show={exibirAprender} onHide={() => concluirAprender()} size="lg" centered backdrop="static">
                    <Modal.Body style={{ padding: '40px 28px 24px', position: 'relative' }}>
                        <button type="button" aria-label="Fechar" title="Fechar" onClick={() => concluirAprender()}
                            style={{ position: 'absolute', top: 14, right: 16, border: 'none', background: 'none', color: '#6b7280', fontSize: 18, cursor: 'pointer', padding: 4, lineHeight: 0 }}>
                            <FaTimes />
                        </button>
                        <EtapaContrato key={aberturasAprender} contexto="cadastro" aoConcluir={concluirAprender} aoPersonalizar={personalizarAprendido} aoFalhar={falhouAprender} />
                    </Modal.Body>
                </Modal>

                {/* Card de Contrato Exemplo - Fictício */}
                <div style={{
                    margin: '24px 16px',
                    border: '2px dashed #ff9800',
                    borderRadius: '12px',
                    backgroundColor: '#fff8e1',
                    overflow: 'hidden'
                }}>
                    <div
                        onClick={() => setExemploExpandido(!exemploExpandido)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px 20px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FaInfoCircle style={{ color: '#e65100', fontSize: '20px' }} />
                            <span style={{ fontWeight: 'bold', color: '#e65100', fontSize: '15px' }}>
                                Exemplo de Contrato com Variáveis (FICTÍCIO - apenas para demonstração)
                            </span>
                        </div>
                        {exemploExpandido
                            ? <FaChevronUp style={{ color: '#e65100' }} />
                            : <FaChevronDown style={{ color: '#e65100' }} />
                        }
                    </div>

                    {exemploExpandido && (
                        <div style={{
                            padding: '0 20px 20px 20px',
                        }}>
                            <div style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #ffe0b2',
                                borderRadius: '8px',
                                padding: '24px',
                                fontFamily: 'serif',
                                fontSize: '14px',
                                lineHeight: '1.8',
                                color: '#333'
                            }}>
                                <div style={{
                                    textAlign: 'center',
                                    marginBottom: '16px',
                                    padding: '8px',
                                    backgroundColor: '#ffebee',
                                    borderRadius: '6px',
                                    border: '1px solid #ef9a9a'
                                }}>
                                    <strong style={{ color: '#c62828', fontSize: '13px' }}>
                                        ⚠ DOCUMENTO FICTÍCIO - APENAS PARA DEMONSTRAÇÃO DO USO DAS VARIÁVEIS ⚠
                                    </strong>
                                </div>

                                <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    CONTRATO DE LOCAÇÃO DE VEÍCULO
                                </h3>

                                <p>
                                    Pelo presente instrumento particular de contrato de locação de veículo, de um lado, como <strong>LOCADOR(A)</strong>,
                                    e de outro lado, como <strong>LOCATÁRIO(A)</strong>, <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{nome_locatario}'}</span>,
                                    portador(a) do CPF/CNPJ nº <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{documento_locatario}'}</span>,
                                    RG nº <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{rg_locatario}'}</span>,
                                    CNH nº <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{cnh_locatario}'}</span>,
                                    residente e domiciliado(a) em <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{endereco_locatario}'}</span>,
                                    telefone <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{telefone_locatario}'}</span>,
                                    e-mail <span style={{ backgroundColor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{email_locatario}'}</span>,
                                    têm entre si justo e acertado o seguinte:
                                </p>

                                <p><strong>CLÁUSULA 1ª - DO OBJETO</strong></p>
                                <p>
                                    O presente contrato tem como objeto a locação do veículo de
                                    marca <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{marca}'}</span>,
                                    modelo <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{modelo}'}</span>,
                                    ano <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{ano}'}</span>,
                                    cor <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{cor}'}</span>,
                                    placa <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{placa}'}</span>,
                                    chassi <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{chassi}'}</span>,
                                    RENAVAM <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{renavam}'}</span>,
                                    com quilometragem inicial de <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{km_inicial}'}</span> km,
                                    avaliado em <span style={{ backgroundColor: '#e8f5e9', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{valor_veiculo}'}</span>.
                                </p>

                                <p><strong>CLÁUSULA 2ª - DO VALOR E PAGAMENTO</strong></p>
                                <p>
                                    O valor do aluguel é de <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{valor_aluguel}'}</span> com
                                    periodicidade <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{periodicidade}'}</span>,
                                    com vencimento todo dia <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{dia_pagamento}'}</span> de cada mês,
                                    iniciando em <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{data_inicio_pagamento}'}</span>.
                                    A caução será de <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{valor_caucao}'}</span>,
                                    totalizando <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{soma_valores}'}</span> na entrada.
                                </p>

                                <p><strong>CLÁUSULA 3ª - DO PRAZO</strong></p>
                                <p>
                                    O prazo mínimo de locação é de <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{prazo_minimo}'}</span>,
                                    com retirada do veículo em <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{data_retirada}'}</span> e
                                    encerramento previsto em <span style={{ backgroundColor: '#fce4ec', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{data_encerramento}'}</span>.
                                </p>

                                <p><strong>CLÁUSULA 4ª - DO FIADOR</strong></p>
                                <p>
                                    O fiador responsável por este contrato é: <span style={{ backgroundColor: '#f3e5f5', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold' }}>{'{fiador}'}</span>.
                                </p>

                                <div style={{
                                    marginTop: '20px',
                                    padding: '12px',
                                    backgroundColor: '#e3f2fd',
                                    borderRadius: '6px',
                                    border: '1px solid #90caf9'
                                }}>
                                    <strong style={{ fontSize: '13px', color: '#1565c0' }}>Legenda das cores:</strong>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '8px', fontSize: '12px' }}>
                                        <span><span style={{ backgroundColor: '#e3f2fd', padding: '2px 8px', borderRadius: '4px' }}>Azul</span> = Dados do Locatário</span>
                                        <span><span style={{ backgroundColor: '#e8f5e9', padding: '2px 8px', borderRadius: '4px' }}>Verde</span> = Dados do Veículo</span>
                                        <span><span style={{ backgroundColor: '#fce4ec', padding: '2px 8px', borderRadius: '4px' }}>Rosa</span> = Dados do Contrato</span>
                                        <span><span style={{ backgroundColor: '#f3e5f5', padding: '2px 8px', borderRadius: '4px' }}>Roxo</span> = Fiador</span>
                                    </div>
                                </div>

                                <div style={{
                                    marginTop: '12px',
                                    padding: '10px',
                                    backgroundColor: '#fff3e0',
                                    borderRadius: '6px',
                                    border: '1px solid #ffcc80',
                                    fontSize: '12px',
                                    color: '#e65100'
                                }}>
                                    <strong>Como usar:</strong> No editor de contrato, utilize as variáveis entre chaves (ex: {'{nome_locatario}'}) no seu documento Word (.docx).
                                    Ao gerar o contrato de uma locação, o sistema substituirá automaticamente cada variável pelo dado real correspondente.
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </LocaSmartLayout>
        </>
    );
}

export default ModeloContratoListagem;

const TituloEscolha = styled.h2`
    margin: 0 0 4px;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
`;

const SubtituloEscolha = styled.p`
    margin: 0 0 18px;
    color: #6b7280;
    font-size: 0.95rem;
`;

const GradeEscolha = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;

    @media (max-width: 640px) { grid-template-columns: 1fr; }
`;

const CartaoEscolha = styled.button`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 20px 18px;
    border: 1.5px solid #dbe3ee;
    border-radius: 12px;
    background: #ffffff;
    text-align: left;
    font: inherit;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;

    &:hover { border-color: #1F467E; box-shadow: 0 6px 18px rgba(31, 70, 126, 0.12); transform: translateY(-1px); }

    .icone { font-size: 26px; color: #1F467E; margin-bottom: 4px; }
    strong { font-size: 1rem; color: #1f2937; }
    span { font-size: 0.85rem; color: #6b7280; line-height: 1.45; }
    .selo {
        position: absolute; top: 12px; right: 12px;
        padding: 2px 9px; border-radius: 999px;
        background: #e7f5ec; color: #1a7f43;
        font-size: 0.7rem; font-weight: 700; line-height: 1.6;
    }
`;
